import React, { FC, useState } from "react";
import { Button, Input, message, Modal, Switch, Tooltip } from "antd";
import TextArea from "antd/lib/input/TextArea";
/*
import validator from "@rjsf/validator-ajv6";
import { withTheme } from "@rjsf/core";
import { Theme } from "@rjsf/antd";
*/
import cn from "classnames";
import { useTranslation } from "react-i18next";
import $authHost from "../../http/auth";
import styles from "./applications.module.css";

// @ts-ignore
/*
const Form = withTheme(Theme);
*/

interface SubmittingData {
  name: string;
  description?: string;
  configuration: any;
  isEnabled: boolean;
}

interface Props {
  open: boolean;
  onClose: Function;
  onSubmit: Function;
}

export const CreateApplicationModal: FC<Props> = ({ open, onClose, onSubmit }) => {
  const [application, setApplication] = useState("");
  const [description, setDescription] = useState("");
  const [configuration, setConfiguration] = useState("");
  const [applicationEnabled, setApplicationEnabled] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState(false);
  /*
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false);
  const [schema, setSchema] = useState("");
  const [schemaObj, setSchemaObj] = useState<Object | null>(null);
  const [configurationObj, setConfigurationObj] = useState<Object | null>(null);
  */

  const { t } = useTranslation("applications");

  /*
  useEffect(() => {
    if (!isFormOpen) {
      return;
    }
    setIsFormOpen(false);
    setSchemaObj(null);
    setConfigurationObj(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schema]);
  */

  const onChangeApplication = (e: React.ChangeEvent<HTMLInputElement>) => {
    setApplication(e.target.value);
  };

  const onChangeDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };

  /*
  const onChangeSchema = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setSchema(e.target.value);
  };
  */

  const onChangeConfiguration = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setConfiguration(e.target.value);
  };

  const onChangeSwitcher = (value: boolean) => {
    setApplicationEnabled(value);
  };

  const closeApplicationModal = () => {
    onClose();
    setApplication("");
    setConfiguration("");
    setApplicationEnabled(false);
    /*
    setIsFormOpen(false);
    setSchema("");
    setSchemaObj(null);
    setConfigurationObj(null);
    */
  };

  const postApplication = (configurationData?: Object) => {
    try {
      /*
      JSON.parse(schema);
      if (!configurationData) {
        JSON.parse(configuration);
      }
      */
      JSON.parse(configuration);
    } catch {
      message.error(t("jsonIsNotValid"));
      return;
    }

    const data: SubmittingData = {
      name: application,
      configuration: configurationData || JSON.parse(configuration),
      isEnabled: applicationEnabled,
      /*
      schema: JSON.parse(schema),
      */
    };

    if (description) {
      data.description = description;
    }

    setSubmitting(false);

    $authHost
      .post("/Applications", data)
      .then((res) => {
        onSubmit(res.data);
        message.success(t("applicationAdded"));
        closeApplicationModal();
      })
      .catch((err) => {
        message.error(err?.response?.data?.title);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onSubmitApplicationModal = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);

    postApplication();
  };

  /*
  const onSubmitApplicationForm = (configurationData: Object) => {
    if (application === "") {
      message.error(t("pleaseInputApplicationName"));
      return;
    }

    setSubmitting(true);

    postApplication(configurationData);
  };

  const onGenerateForm = () => {
    let schemaParsed: Object;
    let configurationParsed: Object | null = null;

    try {
      schemaParsed = JSON.parse(schema);
      if (configuration !== "") {
        configurationParsed = JSON.parse(configuration);
      }
    } catch {
      message.error(t("jsonIsNotValid"));
      return;
    }

    setSchemaObj(schemaParsed);
    if (configurationParsed !== null) {
      setConfigurationObj(configurationParsed);
    }

    setIsFormOpen(true);
  };
  */

  return (
    <Modal
      title={t("createApplication")}
      open={open}
      onCancel={closeApplicationModal}
      destroyOnClose={true}
      footer={
        // !isFormOpen && (
        <>
          <Button disabled={submitting} onClick={closeApplicationModal}>
            {t("cancel")}
          </Button>
          <Button disabled={submitting} htmlType="submit" form="createAppForm">
            {t("submit")}
          </Button>
        </>
        // )
      }
      bodyStyle={{ paddingTop: 0 }}
    >
      <form id="createAppForm" className={styles.createAppForm} onSubmit={onSubmitApplicationModal}>
        <div className={cn(styles.formRow, styles.formItem)}>
          <Input
            required
            placeholder={t("name")}
            className={styles.input}
            value={application}
            onChange={onChangeApplication}
          />
          <Tooltip title={t(applicationEnabled ? "disable" : "enable")}>
            <Switch style={{ marginRight: 10 }} onChange={onChangeSwitcher} />
          </Tooltip>
        </div>
        {/*<TextArea*/}
        {/*  required*/}
        {/*  placeholder={t("schema")}*/}
        {/*  className={cn(styles.textarea, styles.formItem)}*/}
        {/*  value={schema}*/}
        {/*  onChange={onChangeSchema}*/}
        {/*/>*/}
        <TextArea
          placeholder={t("description")}
          className={cn(styles.textarea, styles.formItem)}
          value={description}
          onChange={onChangeDescription}
        />
        <TextArea
          required
          placeholder={t("configuration")}
          className={cn(styles.textarea, styles.formItem)}
          value={configuration}
          onChange={onChangeConfiguration}
        />
      </form>

      {/*<Button onClick={onGenerateForm}>{t("generate")}</Button>*/}

      {/*{isFormOpen && schemaObj && (*/}
      {/*  <Form*/}
      {/*    className="json-form"*/}
      {/*    schema={{ ...schemaObj, $id: "http://json-schema.org/draft-04/schema#" }}*/}
      {/*    formData={configurationObj}*/}
      {/*    uiSchema={{*/}
      {/*      "ui:options": {*/}
      {/*        expandable: false,*/}
      {/*      },*/}
      {/*    }}*/}
      {/*    validator={validator}*/}
      {/*    onSubmit={(value: any) => {*/}
      {/*      onSubmitApplicationForm(value.formData);*/}
      {/*    }}*/}
      {/*    onError={(value: any) => {*/}
      {/*      console.log("error", value);*/}
      {/*    }}*/}
      {/*  ></Form>*/}
      {/*)}*/}
    </Modal>
  );
};
